/** Pages propres aux activités déclarées par l'entreprise (§16.2). */
import { lazy } from 'react';
import type { AppRoute, RouteGate } from '../../app/route-types.js';

const TradeWorkspace = lazy(() => import('./TradeWorkspace.js').then((m) => ({ default: m.TradeWorkspace })));

/** Le relevé s'enregistre dans l'historique de la machine : même droit que le serveur. */
const reading: RouteGate = { anyOf: ['equipment.history.add_official'] };

export const tradesRoutes: AppRoute[] = [
  { path: '/metier', element: <TradeWorkspace />, gate: reading },
  { path: '/metier/:trade', element: <TradeWorkspace />, gate: reading },
];
